"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = maybeAddPeriod;

function maybeAddPeriod(text) {
  if (!text) return text;
  var trimmedText = text.trim();
  var lastChar = trimmedText[trimmedText.length - 1];
  if (lastChar === '.' || lastChar === '!' || lastChar === '?') return trimmedText;
  return trimmedText + '.';
}